'use strict';

export default class Train {
	constructor() {
        // dom els
        this.train = document.querySelector('[data-train]');
        this.trainMain = document.querySelector('[data-train-main]');
        this.trainWrapper = document.querySelector('[data-train-wrapper]');
        this.trainWheels = document.querySelector('[data-train-wheels]');
        this.trainWheelPair = document.querySelector('[data-train-wheels-pair]');
        this.trainTablet = document.querySelector('[data-train-tablet]');
        this.trainWheelMachine = document.querySelector('[data-train-wheel-mashine]');
        this.trainSparks = document.querySelector('[data-train-sparks]');
        this.trainSwarf = document.querySelector('[data-train-swarf]');
        this.trainProfilemetr = document.querySelector('[data-train-profilemetr]');
        this.trainProfilemetrLazer = document.querySelector('[data-train-profilemetr-lazer]');
        this.trainProfilemetrLazerLines = document.querySelector('[data-train-profilemetr-lazer-lines]');

        // consts
        this.initScaleSize = this.train.getBoundingClientRect().width;
        this.saturateStartPoint = 500;
        this.opacityStartPoint = 550;
        this.scaleStartPoint = 1100;
        this.scaleEndPoint = 1300;
        this.trainMaxTranslate = 700;
        this.tabletMachineTranslate = 230;
        this.sparksEndPoint = 1700;
        this.profilemetrStartPoint = this.sparksEndPoint + 200;
        this.profilemetrEndPoint = 3000;
        this.lazerStartPoint = 2200;
        this.trainWrapperMaxScaleIndex = 1.25;
        this.trainWrapperMaxTranslateIndex = 78;
        this.transitionSpeed = 1.4;
        this.opacitySpeed = 5.5;

        // for scroll count
        this.sparksPrevScroll = 0;
        this.lazerLinesPrevScroll = 0;

        document.addEventListener('scroll', this.onScroll.bind(this), false);
	}

	onScroll() {
		let scroll = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
		let newScaleSize = this.initScaleSize + (scroll - this.scaleStartPoint);
		let trainWrapperScaleIndex = newScaleSize / this.initScaleSize;
		let trainWrapperTranslateIndex = (newScaleSize - this.initScaleSize) / 2.5; // 2.5 - just for soft transition

		// train main transitions
		this.train.style.transform = `translateX(${Math.max(-this.trainMaxTranslate, Math.min(0, scroll * this.transitionSpeed - this.trainMaxTranslate))}px)`;
		this.trainMain.style.opacity = Math.max(0.19, Math.min(1, -scroll / this.opacityStartPoint + 2));
		this.trainMain.style.filter = `saturate(${Math.max(0, Math.min(1, -scroll / this.saturateStartPoint + 2))})`;
		this.trainWheels.style.opacity = Math.max(0, Math.min(1, -scroll / this.opacityStartPoint + 2));
		this.trainWheelPair.style.opacity = Math.min(1, Math.max(0, (this.initScaleSize + (scroll - this.opacityStartPoint)) / this.initScaleSize));

		// train scaling, tablet & wheelmachine transition
		if (scroll > this.scaleStartPoint) {
			this.trainWrapper.style.transform = `scale(${Math.max(1, Math.min(this.trainWrapperMaxScaleIndex, trainWrapperScaleIndex))}, ${Math.max(1, Math.min(this.trainWrapperMaxScaleIndex, trainWrapperScaleIndex))}) translate(-${Math.max(0, Math.min(this.trainWrapperMaxTranslateIndex, trainWrapperTranslateIndex))}px, -${Math.max(0, Math.min(this.trainWrapperMaxTranslateIndex, trainWrapperTranslateIndex))}px)`;
			this.trainTablet.style.transform = `translateX(${Math.max(-this.tabletMachineTranslate, Math.min(0, (scroll-this.scaleStartPoint) * this.transitionSpeed - this.tabletMachineTranslate))}px)`;
			this.trainTablet.style.opacity = (Math.min(1, (scroll / this.scaleStartPoint - 1) * this.opacitySpeed)).toFixed(1);
			this.trainWheelMachine.style.transform = `translateX(${Math.max(0, Math.min(this.tabletMachineTranslate, (-scroll + this.scaleStartPoint) * this.transitionSpeed + this.tabletMachineTranslate))}px)`;
			this.trainWheelMachine.style.opacity = (Math.min(1, (scroll / this.scaleStartPoint - 1) * this.opacitySpeed)).toFixed(1);
		} else {
			this.trainTablet.style.opacity = 0;
			this.trainWheelMachine.style.opacity = 0;
		}

		if (scroll > this.scaleStartPoint && scroll < this.scaleEndPoint) {
			this.trainWheelPair.style.transform = `translate(${(newScaleSize - this.initScaleSize) / 30}px, -${(newScaleSize - this.initScaleSize) / 40}px)`; // 30,40 - selected by testing transition values
		}

		// sparks & swarf flashing
		if (scroll > this.scaleEndPoint + 40 && scroll < this.sparksEndPoint) {
			this.trainSparks.style.opacity = (Math.abs(scroll - this.sparksPrevScroll) / 10).toFixed(1);
			this.trainSwarf.style.opacity = 1;
			this.trainSwarf.style.transform = `scale(${Math.min(1, (Math.abs(scroll - this.sparksPrevScroll) / 5).toFixed(1))})`;
			this.sparksPrevScroll = scroll;
		} else if (scroll < this.scaleEndPoint || scroll > this.sparksEndPoint) {
			this.trainSparks.style.opacity = 0;
			this.trainSwarf.style.opacity = 0;
		}
		if (scroll > this.sparksEndPoint + 40) {
			this.trainTablet.style.opacity = 0;
			this.trainWheelMachine.style.opacity = 0;
		}

		// profilemetr
		if (scroll > this.profilemetrStartPoint) {
			this.trainProfilemetr.style.transform = `translateY(${Math.max(0, Math.min(this.tabletMachineTranslate, (-scroll + this.profilemetrStartPoint) * this.transitionSpeed + this.tabletMachineTranslate))}px)`;
			this.trainProfilemetr.style.opacity = (Math.min(1, (scroll / this.profilemetrStartPoint - 1) * 10)).toFixed(1);
		} else {
			this.trainProfilemetr.style.opacity = 0;
		}
		if (scroll > this.lazerStartPoint) {
			this.trainProfilemetrLazer.style.opacity = (Math.min(1, (scroll / this.lazerStartPoint - 1) * 10)).toFixed(1);
		}

		if (scroll > this.lazerStartPoint + 200 && scroll < this.profilemetrEndPoint) {
			this.trainProfilemetrLazerLines.style.opacity = (Math.abs(scroll - this.lazerLinesPrevScroll) / 10).toFixed(1);
			this.lazerLinesPrevScroll = scroll;
		} else if (scroll < this.lazerStartPoint || scroll > this.profilemetrEndPoint) {
			this.trainProfilemetrLazerLines.style.opacity = 0;
		}
	}
}